export default "__VITE_ASSET__f2aa01af__"